module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/quotas/quota-batchs/components/quota-transfer-form/quota-transfer-form.component.css
// module id = ./src/app/quotas/quota-batchs/components/quota-transfer-form/quota-transfer-form.component.css
// module chunks = main